<template>
    <div
        class="sliders-comp md-testimonial"
        :class="theme"
        ref="slidersComp"
        :style="{
            ...transformStyle,
            height: (isMobileSize ? mobileHeight : pcHeight) + 'px'
        }"
        @transitionstart="handleTransitionStart"
        @transitionend="handleTransitionEnd"
        @mouseenter="pause"
        @mouseleave="play"
    >
        <ul :style="{ width: `${totalWidth}px` }">
            <li
                v-for="(item, index) in renderList"
                :key="index"
                @transitionstart.stop="() => {}"
                @transitionend.stop="() => {}"
                class="slide-item"
                :style="{
                    width: `${width}px`,
                    'margin-right': `${marginRight}px`
                }"
            >
                <slot :item="item" :index="index"></slot>
            </li>
        </ul>
    </div>
</template>

<script>
import util from '@/common/util';
const SPACE = false; //  Whether to leave blank
const LAYOUT_REPEAT = 3;
export default {
    emits: ['showarrow', 'disabled'],
    props: {
        theme: {
            type: String,
            required: true
        },
        list: {
            type: Array,
            default: () => []
        },
        config: {
            default: () => { },
            type: Object
        },
        pcHeight: {
            type: Number,
            default: 312
        },
        mobileHeight: {
            type: Number,
            default: 312
        },
        itemPcWidth: {
            type: Number,
            default: 371
        },
        itemMobileWidth: {
            type: Number,
            default: 371
        }
    },
    data: function() {
        return {
            sliderIndex: this.list.length,
            marginRight: 20,
            max: 0,
            rest: false,
            SPACE,
            showArrows: false,
            isMoving: false, //  is it animating
            resetIndexs: [] //  Indexes that need to be reset
        };
    },
    created() {
        this.mountedCallback = util.debounce(this.reCalc, 200);
    },
    mounted() {
        window.addEventListener('resize', this.mountedCallback, false);
        this.mountedCallback();
        this.play();
    },
    beforeDestory() {
        window.removeEventListener('resize', this.mountedCallback);
        this.pause();
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        transformStyle({ isMobileSize, offset, showArrows }) {
            return {
                transform:
                    isMobileSize || !showArrows
                        ? ''
                        : `translateX(${-offset}px)`
            };
        },
        offset({
            isMobileSize,
            sliderIndex,
            max,
            rest,
            SPACE,
            width,
            marginRight
        }) {
            let offset = sliderIndex * (width + marginRight);
            if (sliderIndex === max && rest && !SPACE) {
                offset -= rest;
            }
            return isMobileSize ? 0 : offset;
        },
        width({ isMobileSize, itemPcWidth, itemMobileWidth }) {
            return isMobileSize ? itemMobileWidth : itemPcWidth;
        },
        totalWidth({ isMobileSize, list, width, marginRight }) {
            return !isMobileSize
                ? list.length * LAYOUT_REPEAT * (width + 20) - marginRight
                : list.length * (width + 20) - marginRight;
        },
        disabled({ sliderIndex, max }) {
            return {
                prev: sliderIndex === 0,
                next: sliderIndex >= max
            };
        },
        renderList({ list, showArrows }) {
            return showArrows
                ? new Array(LAYOUT_REPEAT)
                    .fill(1)
                    .map(_ => list)
                    .flat()
                : list;
        }
    },
    methods: {
        reCalc() {
            this.isMoving = false;
            if (this.isMobileSize) {
                this.showArrows = false;
                return;
            }
            this.removeTransition();
            this.getMaxIndex();
        },
        addTransition(speed) {
            let curSpeed = speed || this.config.speed;
            this.$refs.slidersComp.style.transition = `${curSpeed / 1000
                }s transform ease-in-out`;
        },
        handleTransitionStart() {
            this.isMoving = true;
        },
        async handleTransitionEnd() {
            if (this.resetIndexs.includes(this.sliderIndex)) {
                this.pause();
                await this.resetLayout();
                this.play();
            }
            this.isMoving = false;
        },
        async resetLayout() {
            return new Promise((resolve, rejext) => {
                let transition;
                (transition = this.$refs.slidersComp.style.transition) &&
                    (this.$refs.slidersComp.style.transition = 'unset');
                this.sliderIndex = this.list.length;
                setTimeout(() => {
                    this.$refs.slidersComp.style.transition = transition;
                    resolve();
                });
            });
        },
        genResetIndex() {
            this.resetIndexs = [0, this.list.length * (LAYOUT_REPEAT - 1)];
        },
        removeTransition() {
            let el = this.$refs.slidersComp;
            el &&
                el.style.transition !== 'unset' &&
                (this.transition = el.style.transition);
            el && (el.style.transition = 'unset');
        },
        getMaxIndex() {
            this.pause();
            let el = this.$refs.slidersComp;
            if (!el) {
                return; 
            }
            let contentWidth = el.offsetWidth;
            let contentTureWidth = this.totalWidth / LAYOUT_REPEAT;

            if (contentTureWidth <= contentWidth) {
                this.max = this.list.length * LAYOUT_REPEAT;
                this.showArrows = false;
                this.sliderIndex = 0;
            } else {
                let singlePlace = this.width + this.marginRight;
                let count = (contentWidth + this.marginRight) / singlePlace;
                let intCount = Math.floor(count);
                this.rest =
                    count !== intCount ? (count - intCount) * singlePlace : 0;
                this.max = this.list.length * LAYOUT_REPEAT - Math.floor(count);
                this.showArrows = true;
                this.sliderIndex = this.isMobileSize ? 0 : this.list.length;
            }

            this.$nextTick(() => {
                el.style.transition = this.transition;
                this.play();
            });

            this.showArrows && this.genResetIndex();
            this.$emit('showarrow', this.showArrows);
            this.$emit('disabled', this.disabled);
        },
        pause() {
            this.timer && clearInterval(this.timer);
        },
        play() {
            this.timer && clearInterval(this.timer);
            this.addTransition();
            this.$nextTick(() => {
                this.timer = setInterval(() => {
                    if (
                        !this.config.autoPlay ||
                        !this.showArrows ||
                        this.isMobileSize
                    ) {
                        return; 
                    }
                    if (this.disabled.next) {
                        this.sliderIndex = 0; 
                    }
                    this.sliderIndex++;
                    this.$emit('disabled', this.disabled);
                }, this.config.interval);
            });
        },
        next() {
            if (this.isMoving) {
                return; 
            }
            this.pause();
            this.sliderIndex++;
            this.$emit('disabled', this.disabled);
        },
        prev() {
            if (this.isMoving) {
                return; 
            }
            this.pause();
            this.sliderIndex--;
            this.$emit('disabled', this.disabled);
        }
    },
    watch: {
        'config.interval': function(newval) {
            this.pause();
            this.play();
        },
        'config.speed': function(newval) {
            this.addTransition(newval);
        },
        list: {
            handler: function(newVal, oldVal) {
                if (newVal && newVal.length) {
                    this.removeTransition();
                    this.getMaxIndex();
                }
            },
            deep: true
        },
        // isMobileSize() {
        //     this.sliderIndex = 0;
        // }
    }
};
</script>

<style lang="scss">
@import '../slider.scss';
</style>
